import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { CommunicationSetting, KeyLocker, KeyLockerBox, KeyLockerCallForHelp } from "models";

const component = "KeyLockersDashboard";

export const KeyLockersQueryKeys = {
  callForHelp: localQueryKey<KeyLockerCallForHelp[]>({ component, data: "keyLockerCallForHelp" }),
  keyLockers: backendQueryKey<KeyLocker[]>({ component, baseUrl: ENV.keylockerBaseURL, endpoint: "/dashboard/list" }),
  ccSettings: backendQueryKey<CommunicationSetting>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/communication/settings/read" }),
  keyLockerDetails: backendQueryKey<KeyLockerBox[]>({ component, baseUrl: ENV.keylockerBaseURL, endpoint: "/dashboard/details" })
};
